import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import useFetch from "../../hooks/useFetch";
import { Loading } from "../../components/Loading";
import { ServerProblem } from "../../pages/ReRoute/ServerProblem";
import { useState } from "react";
import { User } from "../../interfaces/user/User";
import { SupportServerDialog } from "./SupportServerDialog";
import { SupportServerTable } from "./SupportServerTable";
import SupportServerService from "../../services/SupportServerService";

export const SupportServers = () => {
    const { t } = useTranslation();
    const [cookies] = useCookies(["access_token"]);
    const [showDialog, setShowDialog] = useState(false);
    const [dialogMode, setDialogMode] = useState("edit");
    const [user] = useState<User | null>(
        JSON.parse(localStorage.getItem("user") || "null")
    );

    // Fetch all Support Servers
    const {
        data: serverResponse,
        loading: serversLoading,
        error: serverError,
    } = useFetch({
        url: SupportServerService.getAllSupportServers(),
        access_token: cookies.access_token,
    });

    if (serversLoading) {
        return <Loading />;
    }
    if (serverError) {
        return <ServerProblem />;
    }

    // Extract the credentials array from the response
    const supportServers = serverResponse?.credentials || [];

    const addDialog = () => {
        setDialogMode("add");
        setShowDialog(true);
    };

    return (
        <div>
            <SupportServerDialog
                openState={showDialog}
                setOpenState={setShowDialog}
                targetServer={undefined}
                dialogMode={"add"}
            />

            <Grid item>
                <SupportServerTable 
                    serverList={supportServers} 
                    dialogMode={dialogMode} 
                />
            </Grid>

            {user?.is_superadmin && (
                <Grid item sx={{ mt: 2 }}>
                    <Button variant="contained" onClick={addDialog}>
                        {t("add_support_server")}
                    </Button>
                </Grid>
            )}
        </div>
    );
};
